export enum DocumentType {
    DNI = 'DN',
    NIF = 'NF',
    CIF = 'CI',
    NIE = 'NR',
    NIE_NOT_RESIDENT = 'NN',
    IDENTIFICATION_CARD_NOT_RESIDENT = 'TR',
    IDENTIFICATION_DOCUMENT = 'DI',
    PASSPORT = 'PN',
    PASSPORT_LATIN = 'PL',
    PERMISSION = 'PR',
}
